import { Component, OnChanges, SimpleChanges } from '@angular/core';
import { TopNavComponent } from 'fg-library';
import { allThemes } from './allThemes';

@Component({
    selector: 'fg-client-top-nav',
    templateUrl: './top-nav.component.html',
    styleUrls: ['./top-nav.component.scss'],
    standalone: false
})
export class FgClientTopNavComponent extends TopNavComponent implements OnChanges {
    themes: any = allThemes;
    
    ngOnChanges(changes: SimpleChanges): void {
        if(changes['currentApp'] && this.currentApp?.navigationSchema) {
            this.localConfig.navigationSchema = JSON.parse(this.currentApp.navigationSchema);
        }
    }

    getThemeByName(name: string) {
        return allThemes.find(theme => theme.name === name);
    }
}